import _extends from '@babel/runtime/helpers/extends';
import { forwardRef, Icon } from '@chakra-ui/react';
import * as React from 'react';

var Svg = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.582 18.012 21.124 4.378a1.044 1.044 0 0 1 1.522-.093c.435.406.474 1.1.088 1.554l-12.22 14.436a1.046 1.046 0 0 1-1.48.13L1.396 13.99a1.136 1.136 0 0 1-.166-1.548 1.046 1.046 0 0 1 1.514-.174l6.838 5.744Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
});
var Check = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    as: Svg
  }, props, {
    ref: ref
  }));
});

export { Check };
//# sourceMappingURL=Check.js.map
